import Vue from "vue";

Vue.filter("adjustName", value => {
  value =
    value
      .toString()
      .charAt(0)
      .toUpperCase() + value.toString().slice(1);
  return value;
});
